"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResearchGrant = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("../prelude/PreludeCard");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var ResearchGrant = (function (_super) {
    __extends(ResearchGrant, _super);
    function ResearchGrant() {
        return _super.call(this, {
            name: CardName_1.CardName.RESEARCH_GRANT,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.SCIENCE],
            metadata: {
                cardNumber: 'Y04',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(8);
                }),
                description: 'Gain 8 M€.',
            },
        }) || this;
    }
    ResearchGrant.prototype.play = function (player) {
        player.megaCredits += 8;
        return undefined;
    };
    return ResearchGrant;
}(PreludeCard_1.PreludeCard));
exports.ResearchGrant = ResearchGrant;
